'use client'

import { useEffect } from 'react'
import { useAuthStore } from '@/modules/auth/auth-store'

export function AuthManager({ isAuthenticated }: { isAuthenticated: boolean }) {
  const setIsAuthenticated = useAuthStore((state) => state.setIsAuthenticated)
  useEffect(() => {
    if (isAuthenticated) {
      setIsAuthenticated(isAuthenticated)
    }
  }, [isAuthenticated, setIsAuthenticated])
  return null
}
